"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[845],{

/***/ 5829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CampaignItem; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8756);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98774);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(95889);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75068);
/* harmony import */ var _Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33153);






const CardContent = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  padding: 0.5rem;
`;
const Name = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
  height: 54px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const Flex = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const StyledCard = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Z)(({ outDate }) => `
  box-shadow: 0.1rem 0.1rem 0.5rem 0.1rem rgba(0, 0, 0, 0.1);
  ${outDate &&
    `
  filter: grayscale(100%);
  opacity: 0.6;
  `}
`);
const FromDateToDate = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div ``;
const CampaignItem = (_a) => {
    var { imageUrl, name, targetPath, dateFrom, dateTo } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["imageUrl", "name", "targetPath", "dateFrom", "dateTo"]);
    const formattedDateTo = dateTo
        ? dateTo.replace(/-/g, '/')
        : '2099/12/31T12:00:00Z';
    const outDate = new Date(formattedDateTo).getTime() - new Date().getTime() < 0;
    const dateFromStr = dateFrom ? new Date(dateFrom).toLocaleDateString() : '';
    const dateToStr = dateTo ? new Date(dateTo).toLocaleDateString() : '';
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, Object.assign({}, props, { outDate: outDate }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, { targetPath: targetPath, targetType: "_blank" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .LazyImage */ .w, { aspectRatio: 1.93, src: imageUrl })),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardContent, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Common_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CustomLink */ .x, { targetPath: targetPath, targetType: "_blank" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(Name, null, name)),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(Flex, null,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, !outDate && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(FromDateToDate, null,
                    dateFromStr,
                    dateToStr ? ` - ${dateToStr}` : ''))),
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Button */ .z, { disabled: outDate, tag: "a", href: targetPath, variant: "primary" }, outDate ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)('Đã kết thúc') : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_7__.t)('Xem chi tiết'))))));
};




/***/ }),

/***/ 33153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CustomLink; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91590);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);





const Anchor = _teko_ui__WEBPACK_IMPORTED_MODULE_2__/* .styled.a */ .z.a `
  color: unset;
  text-decoration: unset;
`;
const CustomLink = (_a) => {
    var { targetPath, children, targetType = '_self', passHref = false } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["targetPath", "children", "targetType", "passHref"]);
    if (!targetPath)
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
    const a11yProps = {};
    if (typeof children !== 'string') {
        a11yProps['aria-label'] = 'Image';
    }
    if (targetPath.startsWith('http') || targetPath.startsWith('/'))
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, Object.assign({ target: targetType, href: targetPath }, a11yProps, props), children));
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], { href: passHref ? targetPath : `/search?${targetPath}` },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(Anchor, Object.assign({ target: targetType, href: passHref ? targetPath : `/search?${targetPath}` }, a11yProps, props), children)));
};




/***/ }),

/***/ 6165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ MiniSlides; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76365);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95889);
/* harmony import */ var _PreLoad_PreLoad_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38903);
/* harmony import */ var _CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33153);






const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  border-radius: 0.5rem;
  overflow: hidden;
`;
const MiniSlides = (_a) => {
    var { banners = [], isLoading = false, regionName, height = 140, width = 1232 } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__rest */ ._T)(_a, ["banners", "isLoading", "regionName", "height", "width"]);
    if (isLoading)
        return react__WEBPACK_IMPORTED_MODULE_0__.createElement(_PreLoad_PreLoad_es_js__WEBPACK_IMPORTED_MODULE_3__/* .PreLoad */ .b, { height: height, isLoading: isLoading });
    if (!isLoading && !banners.length)
        return null;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({}, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .t, { autoplay: {
                delay: 2500,
            }, slidesPerView: 1, loop: true, hasNavigation: true }, banners.map((banner, index) => {
            return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { key: index, className: "swiper-slide", "data-track-content": true, "data-content-region-name": regionName || 'topBanner', "data-content-name": banner.campaignName, "data-content-index": index, "data-content-target": banner.targetPath },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_CustomLink_CustomLink_es_js__WEBPACK_IMPORTED_MODULE_5__/* .CustomLink */ .x, { targetPath: banner.targetPath },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w, { borderRadius: 8, height: height, src: banner.image, alt: banner.campaignName, width: width, imageWidth: width, hover: "zoom", cover: true }))));
        }))));
};




/***/ }),

/***/ 38903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ PreLoad; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95520);





const Wrapper = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div `
  position: relative;
  border-radius: 0.5rem;
  background: #fff;
  height: ${(props) => props.height + 'px'};
  user-select: none;
`;
const StyledLogoLoading = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_Loading_LogoLoading_es_js__WEBPACK_IMPORTED_MODULE_2__/* .LogoLoading */ .h) `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;
const PreLoad = (_a) => {
    var { height, isLoading, hideLogo = false, logo } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["height", "isLoading", "hideLogo", "logo"]);
    if (!isLoading)
        return null;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, Object.assign({}, props, { height: height }), !hideLogo && react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledLogoLoading, { logo: logo })));
};




/***/ }),

/***/ 82663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Col; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);





const StyledCol = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ col }) => {
    if (!col) {
        return {
            flex: '1 0 0%',
            minWidth: 0,
        };
    }
    return {
        flex: '0 0 auto',
        width: `${(col / 12) * 100}%`,
        paddingRight: '0.5rem',
        paddingLeft: '0.5rem',
    };
}, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Col = (_a) => {
    var { children, col } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children", "col"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCol, Object.assign({ col: col }, props), children));
};




/***/ }),

/***/ 1134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);




const StyledContainer = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, ({ fluid }) => {
    const styles = {
        width: '100%',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: '1rem',
        paddingRight: '1rem',
    };
    if (!fluid) {
        styles.maxWidth = '1264px';
    }
    return styles;
});
const Container = (props) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledContainer, Object.assign({}, props));




/***/ }),

/***/ 49230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);





const StyledRow = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ noGutters }) => `
  display: flex;
  flex-wrap: wrap;
  ${noGutters
    ? ''
    : `
  margin-left: -0.5rem;
  margin-right: -0.5rem;
  `}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const Row = (_a) => {
    var { children } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children"]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledRow, Object.assign({}, props), children);
};




/***/ }),

/***/ 98774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);





const StyledCard = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(({ theme, withPadding }) => `
  border-radius: 8px;
  background-color: ${theme.colors.white};
  position: relative;
  ${withPadding ? 'padding: .5rem;' : ''}
`, styled_system__WEBPACK_IMPORTED_MODULE_1__.space);
const CardHeader = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div ``;
const CardBody = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div ``;
const CardFooter = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div ``;
const Card = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((_a, ref) => {
    var { children, header, footer, withPadding } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children", "header", "footer", "withPadding"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCard, Object.assign({ ref: ref, withPadding: withPadding }, props),
        header && react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardHeader, { className: "card-header" }, header),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardBody, { className: "card-body" }, children),
        footer && react__WEBPACK_IMPORTED_MODULE_0__.createElement(CardFooter, { className: "card-footer" }, footer)));
});
Card.displayName = 'Card';




/***/ }),

/***/ 5834:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Pagination; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75068);
/* harmony import */ var _atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28697);






const LEFT_PAGE = 'LEFT';
const RIGHT_PAGE = 'RIGHT';
const StyledPagination = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.ul */ .z.ul `
  margin-top: 0;
  margin-bottom: 0;
  width: fit-content;
  display: flex;
`;
const StyledPaginationBtn = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.li */ .z.li(({ theme, disabled, active }) => `
    pointer-events: ${disabled ? 'none' : 'auto'};
    display: inline-block;
    ${active &&
    `color: #fff;
      border-color: ${theme.brand.primary};
      &:hover {
        color: ${theme.brand.primary};
      }`}
  `);
const PageLink = (0,_libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .z)(_atoms_Button_Button_es_js__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .z)(({ theme, active }) => `
  min-width: 36px;
  height: 36px;
  text-align: center;
  box-shadow: none;
  border-color: #ced4da;
  color: ${theme.brand.primary};
  font-size: 12px;
  background-color: #fff;
  padding: 8px;
  margin: 5px;
  &:hover {
    background-color: #f4f4f4;
  }
  ${active &&
    `color: #fff;
    background-color: ${theme.brand.primary};
    border-color: ${theme.brand.primary};
    border-radius: 4px;
    &:hover {
      color: ${theme.brand.primary};
      background-color: ${theme.brand.primary};
      color: #fff;
      border-color: ${theme.brand.primary};
    }
    `}
`);
const DotItem = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.li */ .z.li `
  pointer-events: none;
  display: flex;
  min-width: 36px;
  height: 36px;
  color: ${(props) => props.theme.brand.primary};
  padding: 8px;
  margin: 5px;
  font-size: 12px;
  justify-content: center;
`;
const range = (from, to, step = 1) => {
    return Array.from(Array(to - from + 1).keys()).map((item) => item * step + from);
};
const Pagination = (_a) => {
    var { totalRecords = 0, pageLimit = 30, pageNeighbours = 2, onPageChanged, currentPage } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["totalRecords", "pageLimit", "pageNeighbours", "onPageChanged", "currentPage"]);
    const totalPages = Math.ceil(totalRecords / pageLimit);
    const gotoPage = (page) => {
        onPageChanged(page);
    };
    const handleClick = (page, e) => {
        e.preventDefault();
        gotoPage(page);
    };
    const handleMoveLeft = (e) => {
        e.preventDefault();
        gotoPage(currentPage - 1);
    };
    const handleMoveRight = (e) => {
        e.preventDefault();
        gotoPage(currentPage + 1);
    };
    const fetchPageNumbers = () => {
        const totalNumbers = pageNeighbours * 2 + 3;
        const totalBlocks = totalNumbers + 2;
        if (totalPages > totalBlocks) {
            let pages = [];
            const curr = currentPage > totalPages ? totalPages : currentPage;
            const leftBound = curr - pageNeighbours;
            const rightBound = curr + pageNeighbours;
            const beforeLastPage = totalPages - 1;
            const startPage = leftBound > 2 ? leftBound : 2;
            const endPage = rightBound < beforeLastPage ? rightBound : beforeLastPage;
            pages = range(startPage, endPage);
            const pagesCount = pages.length;
            const singleSpillOffset = totalNumbers - pagesCount - 1;
            const leftSpill = startPage > 2;
            const rightSpill = endPage < beforeLastPage;
            const leftSpillPage = LEFT_PAGE;
            const rightSpillPage = RIGHT_PAGE;
            if (leftSpill && !rightSpill) {
                const extraPages = range(startPage - singleSpillOffset, startPage - 1);
                pages = [leftSpillPage, ...extraPages, ...pages];
            }
            else if (!leftSpill && rightSpill) {
                const extraPages = range(endPage + 1, endPage + singleSpillOffset);
                pages = [...pages, ...extraPages, rightSpillPage];
            }
            else if (leftSpill && rightSpill) {
                pages = [leftSpillPage, ...pages, rightSpillPage];
            }
            return [1, ...pages, totalPages];
        }
        return range(1, totalPages);
    };
    const pages = fetchPageNumbers();
    return pages.length > 0 ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement("nav", Object.assign({}, props),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPagination, null,
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, { disabled: currentPage === 1, "data-track-content": true, "data-content-region-name": "paging", "data-content-name": "nextPage" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, { onClick: handleMoveLeft, "aria-label": "Previous page" },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, { name: "chevron-back", size: 12 }))),
            pages.map((page, index) => {
                if ([LEFT_PAGE, RIGHT_PAGE].includes(page)) {
                    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(DotItem, { key: index }, "...");
                }
                return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, { key: index, active: currentPage === page, "data-track-content": true, "data-content-region-name": "paging", "data-content-name": "gotoPage", "data-content-target": `${page}` },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, { onClick: (e) => handleClick(page, e), active: currentPage === page, "aria-label": "Next page" }, page)));
            }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledPaginationBtn, { disabled: currentPage === totalPages, "data-track-content": true, "data-content-region-name": "paging", "data-content-name": "nextPage" },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(PageLink, { onClick: handleMoveRight },
                    react__WEBPACK_IMPORTED_MODULE_0__.createElement(_atoms_SvgIcon_SvgIcon_es_js__WEBPACK_IMPORTED_MODULE_4__/* .SvgIcon */ .l, { name: "chevron-forward", size: 12 })))))) : null;
};




/***/ }),

/***/ 76365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ Swiper; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18668);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49713);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79215);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9221);
/* harmony import */ var swiper_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46626);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);
/* harmony import */ var _atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16966);







const Wrapper = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_1__/* .styled.div */ .z.div(({ theme }) => `.swiper-container {
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  z-index: 1;
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  transition-property: transform;
  box-sizing: content-box;
}
.swiper-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
}
&:hover {
  .swiper-button-next,
  .swiper-button-prev {
    opacity: 1;
    &.swiper-button-disabled {
      opacity: 0.35;
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  position: absolute;
  top: 50%;
  z-index: 10;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  margin-top: -22px;
  background-color: rgba(168, 168, 168, 0.46);
  opacity: 0;
  &.swiper-button-disabled {
    opacity: 0;
    cursor: auto;
    pointer-events: auto;
  }
}
.swiper-pagination {
position: absolute;
text-align: center;
transform: translate3d(0, 0, 0);
z-index: 10;
}
.swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #ddd;
}
.swiper-container-horizontal {
z-index: 0;
}
.swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
  cursor: pointer;
}
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}
.swiper-pagination-bullet-active {
  background: ${theme.brand.secondary};
  width: 24px;
  border-radius: 8px;
}
.swiper-button-next {
  right: 0;
  left: auto;
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
  &:after {
    mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-forward"] */ .q["chevron-forward"]}");
    content: ' ';
    height: 30px;
    width: 30px;
    mask-size: contain;
    display: inline-block;
    background: #333;
  }
}
.swiper-button-prev {
left: 0;
right: auto;
border-top-right-radius: 100px;
border-bottom-right-radius: 100px;
&:after {
  mask: url("${_atoms_SvgIcon_icons_es_js__WEBPACK_IMPORTED_MODULE_2__/* .iconMap["chevron-back"] */ .q["chevron-back"]}");
  content: ' ';
  height: 30px;
  width: 30px;
  mask-size: contain;
  display: inline-block;
  background: #333;
}
}`);
const Swiper = (_a) => {
    var { children, hasNavigation, hasPagination, className } = _a, props = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["children", "hasNavigation", "hasPagination", "className"]);
    const swiperProps = Object.assign({}, props);
    if (hasNavigation && !props.navigation) {
        swiperProps.navigation = true;
        swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z]);
    }
    if (hasPagination && !props.pagination) {
        swiperProps.pagination = true;
        swiper_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"].use */ .Z.use([swiper_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z]);
    }
    const { slidesPerView = 'auto' } = swiperProps;
    const renderContent = (e, index, slidesPerView) => {
        return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_7__/* .SwiperSlide */ .o, { style: {
                maxWidth: (slidesPerView === 'auto' ? 100 : 100 / slidesPerView) + '%',
            }, key: index }, e));
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { className: className },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .t, Object.assign({}, swiperProps), react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, (e, index) => renderContent(e, index, slidesPerView)))));
};




/***/ }),

/***/ 53318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GN": function() { return /* binding */ ContainerLoading; },
  "gb": function() { return /* binding */ Loading; },
  "b7": function() { return /* binding */ PreLoad; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(20348);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-17.0.2-99ba37d931-b254cc17ce.zip/node_modules/react/index.js
var react = __webpack_require__(89703);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/libs/styled.es.js
var styled_es = __webpack_require__(97204);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ecommerce-virtual-a1ca3a7fda/1/packages/ecommerce/dist/Common/PreLoad/PreLoad.es.js
var PreLoad_es = __webpack_require__(38903);
// EXTERNAL MODULE: ./contexts/GlobalDataContext.tsx
var GlobalDataContext = __webpack_require__(43476);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@teko-ui-virtual-f5d553f239/1/packages/ui/dist/components/atoms/LazyImage/LazyImage.es.js
var LazyImage_es = __webpack_require__(95889);
;// CONCATENATED MODULE: ./components/LogoLoading.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80px;\n  height: 80px;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var Wrapper = styled_es/* styled.div */.z.div(_templateObject());
var Logo = (0,styled_es/* styled */.z)(LazyImage_es/* LazyImage */.w)(_templateObject1());
var Spinner = styled_es/* styled.div */.z.div(function(param) {
    var theme = param.theme;
    return "\n    background: none;\n    @keyframes ldio-yuapljtmof {\n      0% {\n        transform: rotate(0deg);\n      }\n      50% {\n        transform: rotate(180deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    .ldio-yuapljtmof  {\n      position: absolute;\n      top: 0;\n      right: 0;\n      left: 0;\n      bottom: 0;\n      margin: auto;\n      animation: ldio-yuapljtmof 1s linear infinite;\n      width: 70px;\n      height: 70px;\n      border-radius: 50%;\n      box-shadow: 0 2px 0 0 ".concat(theme.brand.loading || '#1435c3', ";\n      box-sizing: content-box;\n    }\n");
});
var LogoLoading = function(_param) {
    var _logo = _param.logo, logo = _logo === void 0 ? '' : _logo, props = _objectWithoutProperties(_param, [
        "logo"
    ]);
    var size = 80;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, _objectSpread({}, props, {
        children: [
            logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                width: size / 2,
                height: size / 2,
                src: logo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "ldio-yuapljtmof"
                })
            })
        ]
    })));
};


;// CONCATENATED MODULE: ./components/Loading.tsx






function Loading_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Loading_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Loading_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Loading_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Loading_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Loading_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Loading_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Loading_templateObject() {
    var data = Loading_taggedTemplateLiteral([
        "\n  background: #fff2;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n"
    ]);
    Loading_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Loading_templateObject1() {
    var data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    Loading_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = Loading_taggedTemplateLiteral([
        "\n  position: relative;\n  transition: opacity 0.3s;\n  &.loading-blur {\n    clear: both;\n    overflow: hidden;\n    opacity: 0.5;\n    user-select: none;\n    pointer-events: none;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = Loading_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  height: 100%;\n  max-height: 400px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var StyledOverlay = styled_es/* styled.div */.z.div(Loading_templateObject());
var Loading = function(param) {
    var isLoading = param.isLoading, children = param.children;
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOverlay, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            })
        ]
    }));
};
var PreLoad = function(_param) {
    var isLoading = _param.isLoading, props = Loading_objectWithoutProperties(_param, [
        "isLoading"
    ]);
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PreLoad_es/* PreLoad */.b, Loading_objectSpread({}, props, {
        isLoading: isLoading,
        logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
    })));
};

var ContainerLoadingWrapper = styled_es/* styled.div */.z.div(Loading_templateObject1());
var Container = styled_es/* styled.div */.z.div(_templateObject2());
var LoadingContainer = styled_es/* styled.div */.z.div(_templateObject3());
var ContainerLoading = function(param) {
    var children = param.children, style = param.style, _isLoading = param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading;
    var ref;
    var logo = (0,GlobalDataContext/* useGlobalData */.U5)().logo;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerLoadingWrapper, {
        children: [
            isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingContainer, {
                style: style,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoLoading, {
                    logo: (ref = logo.loading || logo.lite) === null || ref === void 0 ? void 0 : ref.path
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                className: isLoading ? 'loading-blur' : '',
                children: children
            })
        ]
    }));
};


/***/ }),

/***/ 40845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ PromotionCampaigns; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20348);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49230);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5834);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1134);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82663);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6165);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(5829);
/* harmony import */ var components_Loading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(53318);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19321);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11686);
/* harmony import */ var services__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14827);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34069);










function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 800px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var StyledRow = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X)(_templateObject());
var StyledPagination = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .t)(_templateObject1());
var StyledMiniSlides = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_8__/* .MiniSlides */ .H)(_templateObject2());
var useCampaigns = function(p1) {
    var limit1 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 15;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)([
        '/magento/campaigns',
        p1,
        limit1
    ], function() {
        var _ref = _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_url, p, limit) {
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return services__WEBPACK_IMPORTED_MODULE_9__/* .magentoService.getCampaigns */ .c.getCampaigns(limit, p);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_url, p, limit) {
            return _ref.apply(this, arguments);
        };
    }()), data = ref.data, error = ref.error;
    return {
        loading: !error && !data,
        data: (data === null || data === void 0 ? void 0 : data.data) || {
            data: [],
            totalPage: 0
        }
    };
};
var PromotionCampaigns = function(param) {
    var bannerZone = param.bannerZone;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pageLimit = 15;
    var currentQuery = router.query;
    var queryPage = parseInt(currentQuery.p && currentQuery.p.toString()) || 1;
    var ref = useCampaigns(queryPage, pageLimit), loading = ref.loading, data = ref.data;
    var ref1 = bannerZone ? (0,hooks__WEBPACK_IMPORTED_MODULE_10__/* .useBanners */ .U)(bannerZone) : {
        banners: [],
        loading: false
    }, topSlider = ref1.banners, loadingTopSlider = ref1.loading;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        window.scrollTo(0, 0);
    }, [
        currentQuery
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Loading__WEBPACK_IMPORTED_MODULE_11__/* .Loading */ .gb, {
        top: 150,
        isLoading: loading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_12__/* .Container */ .W, {
            marginY: 16,
            children: [
                bannerZone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledMiniSlides, {
                    height: 200,
                    isLoading: loadingTopSlider,
                    banners: topSlider
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledRow, {
                    children: ((data === null || data === void 0 ? void 0 : data.data) || []).map(function(campaign, index) {
                        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_13__/* .Col */ .J, {
                            marginBottom: 16,
                            col: 4,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_14__/* .CampaignItem */ .x, {
                                name: campaign.name,
                                imageUrl: campaign.thumbnail || campaign.image_url,
                                targetPath: campaign.target,
                                dateFrom: campaign.date_from,
                                dateTo: campaign.date_to
                            })
                        }, index));
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledPagination, {
                        totalRecords: pageLimit * ((data === null || data === void 0 ? void 0 : data.totalPage) || 1),
                        pageLimit: pageLimit,
                        currentPage: queryPage,
                        onPageChanged: function(pageNumber) {
                            router.push({
                                pathname: router.pathname,
                                query: {
                                    p: pageNumber
                                }
                            });
                        }
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 14827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ magentoService; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75540);


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var MagentoService = /*#__PURE__*/ function() {
    "use strict";
    function MagentoService() {
        _classCallCheck(this, MagentoService);
    }
    _createClass(MagentoService, [
        {
            key: "getBanks",
            value: function getBanks() {
                return _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return _clients__WEBPACK_IMPORTED_MODULE_1__/* .serverApi.get */ .I1.get('/banks');
                            case 2:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "getCustomData",
            value: function getCustomData(code) {
                return _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return _clients__WEBPACK_IMPORTED_MODULE_1__/* .magentoApi.get */ ._6.get('/content/getCustomData', {
                                    params: {
                                        code: code
                                    }
                                });
                            case 2:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "getCampaigns",
            value: function getCampaigns(limit, p) {
                return _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return _clients__WEBPACK_IMPORTED_MODULE_1__/* .magentoApi.get */ ._6.get('/promotion/getPromoCampaigns', {
                                    params: {
                                        limit: limit,
                                        p: p
                                    }
                                });
                            case 2:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "getShowrooms",
            value: function getShowrooms(products) {
                return _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                return _ctx.abrupt("return", _clients__WEBPACK_IMPORTED_MODULE_1__/* .magentoApi.post */ ._6.post('/address/showrooms', products).then(function(res) {
                                    return res.data;
                                }));
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "getContactContent",
            value: // 23: desktop, 27: mobile
            function getContactContent(store) {
                return _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                return _ctx.abrupt("return", _clients__WEBPACK_IMPORTED_MODULE_1__/* .magentoApi.get */ ._6.get("/address/getContact?store=".concat(store)).then(function(param) {
                                    var data = param.data;
                                    return (data === null || data === void 0 ? void 0 : data.html_content) || '';
                                }));
                            case 1:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return MagentoService;
}();
var magentoService = new MagentoService();


/***/ }),

/***/ 9221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _utils_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96045);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96912);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Navigation = {
  toggleEl: function toggleEl($el, disabled) {
    $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
    if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
  },
  update: function update() {
    // Update Navigation Buttons
    var swiper = this;
    var params = swiper.params.navigation;
    var toggleEl = swiper.navigation.toggleEl;
    if (swiper.params.loop) return;
    var _swiper$navigation = swiper.navigation,
        $nextEl = _swiper$navigation.$nextEl,
        $prevEl = _swiper$navigation.$prevEl;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        toggleEl($prevEl, true);
      } else {
        toggleEl($prevEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        toggleEl($nextEl, true);
      } else {
        toggleEl($nextEl, false);
      }

      if (swiper.params.watchOverflow && swiper.enabled) {
        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  },
  onPrevClick: function onPrevClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop) return;
    swiper.slidePrev();
  },
  onNextClick: function onNextClick(e) {
    var swiper = this;
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop) return;
    swiper.slideNext();
  },
  init: function init() {
    var swiper = this;
    var params = swiper.params.navigation;
    swiper.params.navigation = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .createElementIfNotDefined */ .Up)(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    var $nextEl;
    var $prevEl;

    if (params.nextEl) {
      $nextEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.nextEl);

      if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
        $nextEl = swiper.$el.find(params.nextEl);
      }
    }

    if (params.prevEl) {
      $prevEl = (0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(params.prevEl);

      if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
        $prevEl = swiper.$el.find(params.prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', swiper.navigation.onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', swiper.navigation.onPrevClick);
    }

    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .extend */ .l7)(swiper.navigation, {
      $nextEl: $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl: $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  },
  destroy: function destroy() {
    var swiper = this;
    var _swiper$navigation2 = swiper.navigation,
        $nextEl = _swiper$navigation2.$nextEl,
        $prevEl = _swiper$navigation2.$prevEl;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', swiper.navigation.onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', swiper.navigation.onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }
};
/* harmony default export */ __webpack_exports__["Z"] = ({
  name: 'navigation',
  params: {
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock'
    }
  },
  create: function create() {
    var swiper = this;
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .bindModuleMethods */ .cR)(swiper, {
      navigation: _extends({}, Navigation)
    });
  },
  on: {
    init: function init(swiper) {
      swiper.navigation.init();
      swiper.navigation.update();
    },
    toEdge: function toEdge(swiper) {
      swiper.navigation.update();
    },
    fromEdge: function fromEdge(swiper) {
      swiper.navigation.update();
    },
    destroy: function destroy(swiper) {
      swiper.navigation.destroy();
    },
    'enable disable': function enableDisable(swiper) {
      var _swiper$navigation3 = swiper.navigation,
          $nextEl = _swiper$navigation3.$nextEl,
          $prevEl = _swiper$navigation3.$prevEl;

      if ($nextEl) {
        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }

      if ($prevEl) {
        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
      }
    },
    click: function click(swiper, e) {
      var _swiper$navigation4 = swiper.navigation,
          $nextEl = _swiper$navigation4.$nextEl,
          $prevEl = _swiper$navigation4.$prevEl;
      var targetEl = e.target;

      if (swiper.params.navigation.hideOnClick && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($prevEl) && !(0,_utils_dom__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(targetEl).is($nextEl)) {
        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
        var isHidden;

        if ($nextEl) {
          isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
        } else if ($prevEl) {
          isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
        }

        if (isHidden === true) {
          swiper.emit('navigationShow');
        } else {
          swiper.emit('navigationHide');
        }

        if ($nextEl) {
          $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
        }

        if ($prevEl) {
          $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
      }
    }
  }
});

/***/ })

}]);